import InfiniteList from '@comp/InfiniteList/InfiniteList';
import useCombatFilter from './Common/useCombatFilter';
import useCombatFetch from './Common/useCombatFetch';
import CombatCard from '../Common/CombatCard/CombatCard';
import Filters from './Filters';
import Empty from './Empty';

const Landing = () => {
  const {
    showFirstLevel,
    selectedFirstLevel,
    firstLevelOptions,
    handleOnFirstLevelChange,
    showSecondLevel,
    selectedSeceondLevel,
    secondLevelOptions,
    handleOnSecondLevelChange
  } = useCombatFilter();

  const { loadMore, combatsData, isLoading } = useCombatFetch({
    selectedFirstLevel,
    selectedSeceondLevel
  });

  const renderCombat = (combat) => {
    return <CombatCard key={combat.uid} data={combat} />;
  };

  const renderCombats = () => {
    if (isLoading || !combatsData?.results?.length) {
      return <Empty type={selectedFirstLevel.value} />;
    }

    return (
      <InfiniteList
        data={combatsData}
        loadMore={loadMore}
        _renderItem={renderCombat}
        gridColumn="span 18"
        loaderColor="var(--color-i-blue)"
      />
    );
  };

  return (
    <>
      <Filters
        showFirstLevel={showFirstLevel}
        selectedFirstLevel={selectedFirstLevel}
        firstLevelOptions={firstLevelOptions}
        handleOnFirstLevelChange={handleOnFirstLevelChange}
        showSecondLevel={showSecondLevel}
        selectedSeceondLevel={selectedSeceondLevel}
        secondLevelOptions={secondLevelOptions}
        handleOnSecondLevelChange={handleOnSecondLevelChange}
      />
      {renderCombats()}
    </>
  );
};

export default Landing;
